module.exports = __webpack_public_path__ + "img/map.837df950.svg";